import type { IconSvgObject } from './types';

const MagicWand02Icon: IconSvgObject = [
  ["path", { d: "M17.5 17.5L21 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4.5 4.5L7 11L3 15L9 15.5L12 21L14 14.5L20.5 12L15 9V3L10.5 7L4.5 4.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MagicWand02Icon;
